
export default {
  name: "ReviewStars",
  props: {
    stars: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 5,
    },
    reviewId: {
      type: Number,
      required: true,
    },
  },
};
